"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ResourceGrid.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ResourceGridMethods = require("./ResourceGridMethods");
var _FilterSection = _interopRequireDefault(require("../FilterSection/FilterSection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ResourceGrid = _ref => {
  let {
    content,
    functTest = false
  } = _ref;
  const {
    cards,
    allFilters,
    filtersTitle,
    introSection,
    type = "bounded_cards",
    showRSSFeed,
    rssFeedButton,
    displayCardText
  } = content;

  // max number of cards per page
  const cardsPerPage = 9;
  const [numCardsVisible, setNumCardsVisible] = (0, _react.useState)(cardsPerPage);

  // array of currently applied filters + reducer functions for filter operations
  const [activeFilters, setActiveFiltersDispatch] = (0, _react.useReducer)(activeFilterReducer, [], createInitialState);

  // filtered and paginated cards
  const [paginatedCards, setPaginatedCards] = (0, _react.useState)(cards);
  const [displayLoadMoreButton, setDisplayLoadMoreButton] = (0, _react.useState)(true);

  // set initial state for filter list to empty array, so no filtering happens by default
  function createInitialState() {
    return [];
  }
  (0, _react.useEffect)(() => {
    const resourceCards = (0, _ResourceGridMethods.filterResourceCards)(cards, activeFilters);
    if (resourceCards?.length > numCardsVisible) {
      setPaginatedCards(resourceCards?.slice(0, numCardsVisible));
      // if more than 9 cards are returned, paginate them to 9
      setDisplayLoadMoreButton(true);
    } else {
      setPaginatedCards(resourceCards);
      setDisplayLoadMoreButton(false);
    }
  }, [activeFilters, numCardsVisible]);
  (0, _react.useEffect)(() => {
    // each time filters change, re-paginate the cards a maximum of 9
    setNumCardsVisible(cardsPerPage);
  }, [activeFilters]);
  function activeFilterReducer(state, action) {
    if (action.type === 'add_filter') {
      // if there's current filters, merge new filter into state array
      if (state != undefined) {
        return [...state, action.filter];
      }
      // otherwise set the first filter
      return [action.filter];
    } else if (action.type === 'remove_filter') {
      // filter out clicked filter from activeFilters array
      return [...state.filter(filter => filter.id != action.filter.id)];
    } else if (action.type === 'clear_filters') {
      // override state array with blank array (default value)
      return createInitialState();
    }
  }
  const loadMoreCards = e => {
    // adds another 9 cards to the list
    e.preventDefault();
    setNumCardsVisible(numCardsVisible + cardsPerPage);
  };
  const filterOptionClickHandler = (e, filter) => {
    if (activeFilters?.includes(filter)) {
      removeActiveFilterHandler(e, filter);
    } else {
      setActiveFiltersDispatch({
        activeFilters,
        type: 'add_filter',
        filter: filter
      });
    }
  };
  const removeActiveFilterHandler = (e, filter) => {
    setActiveFiltersDispatch({
      activeFilters,
      type: 'remove_filter',
      filter: filter
    });
  };
  const clearAllFiltersHandler = () => {
    setActiveFiltersDispatch({
      activeFilters,
      type: 'clear_filters'
    });
    setNumCardsVisible(9);
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `luna-resource-grid--wrapper`
  }, /*#__PURE__*/_react.default.createElement(_FilterSection.default, {
    content: {
      introSection,
      allFilters,
      filtersTitle,
      filterOptionClickHandler,
      activeFilters,
      clearAllFiltersHandler,
      removeActiveFilterHandler,
      showRSSFeed,
      rssFeedButton
    }
  }), (0, _ResourceGridMethods.renderResourceGrid)(paginatedCards, functTest, displayCardText, type), (0, _ResourceGridMethods.renderLoadMoreSection)(loadMoreCards, displayLoadMoreButton));
};
var _default = ResourceGrid;
exports.default = _default;
ResourceGrid.propTypes = {
  content: _propTypes.default.shape({
    image: _propTypes.default.object,
    eyebrow: _propTypes.default.string,
    header: _propTypes.default.string,
    cardLink: _propTypes.default.shape({
      url: _propTypes.default.string,
      text: _propTypes.default.string
    }),
    showRSSFeed: _propTypes.default.bool
  })
};